import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../../AgentForm.module.scss';
import AgentFormTextbox from './AgentFormTextbox';
import AgentFormRadioChip from './AgentFormRadioChip';
import WarningSection from './WarningSection';
import { VERIFICATION_MESSAGE } from '../../constants/constants';
import AgentBaseLocation from './AgentBaseLocation';
import VerificationComponent from './VerificationComponent';
import { IAgentAllocationDetailsProps } from '../../interfaces/types';

const AgentAllocationDetails = (props: IAgentAllocationDetailsProps) => {
  const {
    isPincodeAndBaseLocationMandatory = false,
    control,
    errors,
    isEditDisabled,
    agentData,
    getValues,
    handleAgentPincodeChange,
    handleCoordinatesChange,
    handlePincodeVerification,
    isPincodeMismatch,
    showLocationVerificationToast,
    reverseGeocodedAgentCity,
    reverseGeocodedAgentPincode,
    locationVerificationStatus,
    showVerifyButton,
    showCityPincode,
    isMisMatchedPincode
  } = props;

  return (
    <div>
      <div className={'pt-4 pl-5 mt-4 flex'}>
        <Typography variant={'h4'} color="var(--navi-color-gray-c2)" className="pr-1">
          Agent Allocation Details
        </Typography>
        <Typography variant="p4" color="var(--navi-color-gray-c3)">
          (for next month)
        </Typography>
      </div>

      <div className={styles.inputContainer}>
        <AgentFormRadioChip
          control={control}
          name={'agentType'}
          rules={{ required: false }}
          errors={errors}
          isEditDisabled={isEditDisabled}
          styles={styles}
          inputLabel={'Agent Type'}
          defaultValue={
            agentData?.agentAllocationProfileView?.currentMonthAllocationView?.metadata
              ?.agentBandwidthType || ''
          }
          showRequiredIcon={false}
        />
      </div>

      <div className={styles.inputContainer}>
        <AgentFormTextbox
          control={control}
          name="nextMonthAgentPincode"
          rules={{
            required: isPincodeAndBaseLocationMandatory,
            minLength: 6,
            maxLength: 6,
            pattern: /^[0-9]{6}$/i
          }}
          inputLabel={'Agent Pincode'}
          placeholder={'Enter 6-digit pincode'}
          isEditDisabled={isEditDisabled}
          errors={errors}
          styles={styles}
          validationMessage={'Enter 6 digit valid pincode'}
          onChangeCallback={handleAgentPincodeChange}
          isRequired={isPincodeAndBaseLocationMandatory}
        />
      </div>

      {isPincodeMismatch && (
        <WarningSection
          message={VERIFICATION_MESSAGE.MISMATCHED_PINCODE}
          color={'var(--grayscale-2)'}
          iconColor={'var(--grayscale-2)'}
          showTriangle={false}
          bgColor="var(--blue-bg)"
        />
      )}

      <AgentBaseLocation
        latitude={'nextMonthLatitude'}
        longitude={'nextMonthLongitude'}
        control={control}
        errors={errors}
        isEditDisabled={isEditDisabled}
        callbackFn={handleCoordinatesChange}
        showCurrentMonthLabel={false}
        isMandatory={isPincodeAndBaseLocationMandatory}
      />

      <VerificationComponent
        getValues={getValues}
        locationVerificationStatus={locationVerificationStatus}
        showLocationVerificationToast={showLocationVerificationToast}
        isEditDisabled={isEditDisabled}
        reverseGeocodedAgentCity={reverseGeocodedAgentCity}
        reverseGeocodedAgentPincode={reverseGeocodedAgentPincode}
        handleVerification={handlePincodeVerification}
        showVerifyButton={showVerifyButton}
        showCityPincode={showCityPincode}
        isMisMatchedState={isMisMatchedPincode}
        warningMessage={VERIFICATION_MESSAGE.MISMATCHED_PINCODE_LOCATION}
      />
    </div>
  );
};

export default AgentAllocationDetails;
